export default "__VITE_ASSET__m5RR2OA___"